import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonToString'
})
export class JsonToStringPipe implements PipeTransform {

  transform(value): any {
    const output = [];

    const jsonResult = JSON.parse(value);
    for (const key in jsonResult) {
      if (typeof jsonResult[key] === 'string') {
        output.push(`${key}: ${jsonResult[key]}`);
      }
    }
    return output;
  }
}
